import BusTipsContent
    from "@SearchResults/features/staticContent/features/singleModal/features/tips/components/BusTipsContent";
import FerryTipsContent
    from "@SearchResults/features/staticContent/features/singleModal/features/tips/components/FerryTipsContent";
import TrainTipsContent
    from "@SearchResults/features/staticContent/features/singleModal/features/tips/components/TrainTipsContent";
import FlightTipsContent
    from "@SearchResults/features/staticContent/features/singleModal/features/tips/components/FlightTipsContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import VanTipsContent
    from "@SearchResults/features/staticContent/features/singleModal/features/tips/components/VanTipsContent";

interface TipsPerTransportTypeContentProps {
    transportType: TransportTypesType,
}

function TipsPerTransportTypeContent({transportType}: TipsPerTransportTypeContentProps) {
    const map: Record<TransportTypesType, any> = {
        bus: BusTipsContent,
        ferry: FerryTipsContent,
        train: TrainTipsContent,
        plane: FlightTipsContent,
        privateTransfer: VanTipsContent,
    }

    const Tips = map[transportType]

    return (
        <Tips/>
    )
}

export default TipsPerTransportTypeContent